import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['rows', 'filter', 'reset'];

    initialize () {
        super.initialize();
        this.reset();
    }

    filterColumn (event) {
        if (!event.target.value) {
            delete this.activeFilters[event.params.column];
        } else {
            this.activeFilters[event.params.column] = event.target.value;
        }

        this.#applyFilters();

        this.resetTarget.disabled = Object.values(this.activeFilters).length ? '' : 'disabled';
    }

    reset () {
        this.filterTargets.forEach((el) => {
            el.value = '';

            // fix custom select menu not reacting on value change
            el.dispatchEvent(new Event('change'));
        });

        this.activeFilters = {};
        this.#applyFilters();

        this.resetTarget.disabled = 'disabled';
    }

    #applyFilters () {
        this.rowsTargets.forEach((r) => {
            r.classList.remove('invisible');
        });

        this.rowsTargets.forEach((r) => {
            for (const column in this.activeFilters) {
                const col = r.querySelector(`[data-techfilter-column="${column}"]`);

                if (col && col.innerText !== this.activeFilters[column]) {
                    r.classList.add('invisible');
                    return;
                }
            }
        });
    }
}
